import { BASE_API } from "./constants";

export function getSession() {
    const session = JSON.parse(localStorage.getItem("session"));
    if (!session) return null;

    const expired = Date.now() - session.loginAt > 1000 * 60 * 60 * 24 * 30; // 1 hour
    if (expired) {
        localStorage.removeItem("session");
        return null;
    }

    return session;
}

export function setSession(session) {
    localStorage.setItem("session", JSON.stringify(session));
    // window.dispatchEvent(new Event("session-updated"));
}

export function getRole(session) {
    let user_role = session?.user?.user_role || null;
    return user_role;
}

export function getEventEndTime(event_time, training_duration) {
  if (!event_time || !training_duration) return "";

  const [hours, minutes] = event_time.split(":").map(Number);
  const startDate = new Date();
  startDate.setHours(hours);
  startDate.setMinutes(minutes);

  const endDate = new Date(startDate.getTime() + training_duration * 60000); // 60000 = ms per minute

  const endHours = String(endDate.getHours()).padStart(2, "0");
  const endMinutes = String(endDate.getMinutes()).padStart(2, "0");

  return `${endHours}:${endMinutes}`;
}

export const daysInCurrentMonth = (date = new Date()) => {
    const y = date.getFullYear();
    const m = date.getMonth();
    return new Date(y, m + 1, 0).getDate();
};



export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
// export const toLowerCase = str

export function isoToRo(dateIso) {
  if (!dateIso) return "";
  const [yyyy, mm, dd] = dateIso.split("-");
  return `${dd}.${mm}.${yyyy}`;  // 2025-07-01 → 01.07.2025
}

// api.js
export async function fetchTeamBySlug(slug) {
    const res = await fetch(`${BASE_API}/api/team-by-slug/${slug}`);
    const json = await res.json();
    if (!res.ok) throw new Error(json.error || "Eroare team-by-slug");
    return json.team;
}



// Universal

